// src/components/layout/ProtectedLayout.tsx
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import bg from "../../assets/images/bgmain.jpg";

const ProtectedLayout: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [compact, setCompact] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 992); // <992px = mobile/tablet

  // handle window resize
  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // lock body scroll when drawer is open
  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileOpen]);

  // close drawer on Escape
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setMobileOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="flex h-screen bg-white !overflow-hidden">
      {/* Desktop sidebar (>=900px) */}
      {!isMobileView && (
        <div
          className={`flex  flex-shrink-0 transition-all duration-300 ease-in-out overflow-hidden ${compact ? "w-20" : "w-64"} `}
          style={{ willChange: "width" }}
        >
          <Sidebar
            compact={compact}
            onToggleCompact={() => setCompact((s) => !s)}
          />
        </div>
      )}

      {/* Mobile/Tablet drawer (<900px) */}
      {isMobileView && (
        <div
          className={`fixed inset-0 z-40 flex ${mobileOpen ? "" : "pointer-events-none"}`}
          aria-hidden={!mobileOpen}
        >
          {/* overlay */}
          <div
            className={`fixed inset-0 bg-black/40 transition-opacity ${
              mobileOpen ? "opacity-100" : "opacity-0"
            }`}
            onClick={() => setMobileOpen(false)}
          />

          {/* sliding panel */}
          <div
            className={`relative bg-white w-64 max-w-full h-full transform transition-transform duration-300 ${
              mobileOpen ? "translate-x-0" : "-translate-x-full"
            }`}
          >
            <Sidebar isMobile onClose={() => setMobileOpen(false)} />
          </div>
        </div>
      )}

      {/* main content */}
      <div className="flex-1 flex flex-col  md:ps-0  h-screen overflow-hidden ">
        <Topbar
          onOpenMobile={() => setMobileOpen(true)}
          compact={compact}
          onToggleCompact={() => setCompact((s) => !s)}
          isMobileView={isMobileView}
          className="sticky top-0 z-30 "
        />
        <main
          className="pb-3 px-2 overflow-auto flex-1 scrollbar-thin-gray bg-cover bg-center bg-no-repeat "
          style={{
            // backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.09), rgba(0, 0, 0, 0.11)), url(${bg})`,
            background: "#010F2A",
            willChange: "width",
          }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default ProtectedLayout;
